import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Footer from "layouts/authentication/components/Footer";
import OrderService from "services/OrderService";

export default () => {
    const { guid } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password.length < 6) {
            setError("Código inválido!");
            return
        }

        setError("");

        try {
            const response = await OrderService
                .getOrders(guid, password)
                .catch((e) => { 
                    console.error("Error API: ", e);
                });

            const order = response.data.data[0];
            if (order) {
                navigate(`/pedidos/${guid}`, { state: { pw: password } });
            }
            else 
            {
                setError("Código inválido!");
            }
        }
        catch(e) {
            setError("Código inválido!");
            console.error("Validação do código: ", e);
        }
    };

    return (
        <PageLayout>
            <MDBox px={1} width="100%" height="100vh" mx="auto">
                <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
                        <Card sx={{ width: "570px" }}>
                            <MDBox mt={3} textAlign="center" >
                                <MDTypography variant="subtitle1" color="text" fontWeight='bold'>
                                    Para acessar o pedido, selecione uma opção:
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={4} pb={3} px={3} textAlign="center" >
                                <MDBox mt={1}>
                                    <MDButton variant="gradient" color="info" fullWidth onClick={() => navigate("/login", { state: { order: {guid: guid} } })} >
                                        Entrar
                                    </MDButton>
                                </MDBox>
                                <MDBox mt={1}>
                                    <MDTypography variant="caption" color="text" fontWeight='bold'>
                                        ou
                                    </MDTypography>
                                </MDBox>
                                <MDBox mt={1}>
                                    <MDButton variant="gradient" color="info" fullWidth onClick={() => navigate("/sign-up", { state: { order: {guid: guid} } })} >
                                        Faça seu cadastro
                                    </MDButton>
                                </MDBox>
                                <MDBox mt={1}>
                                    <MDTypography variant="caption" color="text" fontWeight='bold'>
                                        ou
                                    </MDTypography>
                                </MDBox>
                                <MDBox mt={1}>
                                    <MDTypography variant="body2" color="text" fontWeight='bold' >
                                        Digite seu código enviado por e-mail
                                    </MDTypography>
                                    <MDTypography variant="overline" color="text" sx={{ fontSize: "7pt" }} >
                                        Dessa forma não terá acesso ao Painel de Fornecedores e ao Histórico de Ofertas e Pedidos atendidos.
                                    </MDTypography>
                                </MDBox>
                                <MDBox component="form" role="form" onSubmit={handleSubmit} textAlign="center" >
                                    <MDBox mt={2} >
                                        <MDInput type="text" value={password} onChange={(e) => setPassword(e.target.value)} justifyContent="center" textAlign="center" />
                                    </MDBox>
                                    <MDBox mt={2} mb={1}>
                                        <MDButton variant="gradient" color="info" type="submit"  >
                                            Enviar
                                        </MDButton>
                                    </MDBox>
                                    {error && (
                                    <MDBox mt={2}>
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                        {error}
                                        </MDTypography>
                                    </MDBox>
                                    )}
                                </MDBox>
                            </MDBox>
                        </Card>
                </Grid>
            </MDBox>
            <Footer black />
        </PageLayout>
        
    )
}